import PropTypes from "prop-types"
import React, { useState } from "react"
import { useMutation } from "react-query"

import Toggle from "src/components/Toggle"

import { toggleAdvancedReceiptsSetting } from "src/api/Settings"

import { useToast } from "src/hooks/use_toast"

const AdvancedReceiptsSettings = ({
  advancedReceiptsEnabled,
  paperReceiptsPath,
}) => {
  const [checked, setChecked] = useState(advancedReceiptsEnabled)
  const showToast = useToast()

  const { mutate, isLoading } = useMutation(
    (data) => toggleAdvancedReceiptsSetting({ data }),
    {
      onSuccess: (data) => {
        const message = data.advancedReceiptsEnabled
          ? "Advanced receipts enabled"
          : "Advanced receipts disabled"
        showToast(message, { type: "success" })
      },
      onError: () => {
        showToast(
          "Something went wrong. Please reload the page and contact mayday@dockwa.com if the issue persists.",
          { type: "error" }
        )
      },
    }
  )

  const handleClick = () => {
    mutate({ advanced_receipts: !checked })

    setChecked(!checked)
  }

  return (
    <>
      <h2 className="mb-4 mt-0 text-lg font-semibold">Advanced Receipts</h2>
      <div className="flex">
        <Toggle
          checked={checked}
          onChange={handleClick}
          name="advancedReceipts"
          disabled={isLoading}
        />
        <div className="ml-2 font-normal text-gray-700">
          Enable advanced receipts
        </div>
      </div>
      {checked && (
        <div className="mt-4">
          <a href={paperReceiptsPath} className="btn btn-secondary">
            Configure Advanced Receipts
          </a>
        </div>
      )}
    </>
  )
}

AdvancedReceiptsSettings.propTypes = {
  advancedReceiptsEnabled: PropTypes.bool.isRequired,
  paperReceiptsPath: PropTypes.string.isRequired,
}

export default AdvancedReceiptsSettings
